import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { hasUserWindowHadFocusSince } from 'owa-analytics/lib/utils/visibilityState';

const IMAGEPROXY_DATAPOINT_NAME = 'loadFromImageProxy';

export enum ImageProxyEndpoint {
    ModelD = 'ModelD',
    ModelB = 'ModelB',
}

export type ImageProxyTelemetryConfig = {
    logEvery: number;
    proxyCount: number;
};

export interface ImageProxyDatapoint {
    endWithSuccess: () => void;
    endWithError: PerformanceDatapoint['endWithError'];
    addCustomProperty: PerformanceDatapoint['addCustomProperty'];
}

export default function createImageProxyDatapoint(
    dimensions: {
        endpoint: ImageProxyEndpoint;
    },
    config: ImageProxyTelemetryConfig
): ImageProxyDatapoint {
    if (config.proxyCount % config.logEvery != 0) {
        const fakeFn = () => Promise.resolve();
        return { endWithSuccess: fakeFn, endWithError: fakeFn, addCustomProperty: fakeFn };
    }

    const startTime = new Date().getTime();
    // The vol for external image can be really big so we want to start sampling it more aggressively
    // We will start with every 100, and watch the vol and decide if we want to reduce more or increase
    const dp: any = new PerformanceDatapoint(IMAGEPROXY_DATAPOINT_NAME, {
        sessionSampleRate: 10,
    });

    // pass an array so that the keys are owa_N, which gets us automatic graphing somewhere (per @jarmit)
    dp.addCustomData(Object.values(dimensions));

    dp.endWithSuccess = () => {
        dp.end(
            undefined,
            hasUserWindowHadFocusSince(startTime)
                ? DatapointStatus.BackgroundSuccess
                : DatapointStatus.Success
        );
    };

    return dp;
}
